/* ============================================================================
   PRODUCT PAGES

   Two additions, both scoped to /products/*:
     1. a route into the 3D builder on bikes that have one
     2. a slim title bar on phones, once the real title scrolls away
   ============================================================================ */
(function () {

  var BUILDERS = {
    'custom-mini-surron': '/pages/build-surron'
  };

  function handle() {
    var m = location.pathname.match(/\/products\/([^?#\/]+)/);
    return m ? m[1] : null;
  }

  /* ==========================================================================
     1. ROUTE INTO THE BUILDER

     A configurable bike has a product page with variant buttons and a builder
     page with a 3D configurator, and the product page never mentioned the
     builder existed. Anyone arriving from search or a shared link got buttons
     that cannot express forks, seat, controller, battery or motor cover at
     all, and no hint that the better version of the page exists.
     ========================================================================== */
  function mountConfigure() {
    var h = handle();
    if (!h) return true;

    var target = BUILDERS[h];
    if (!target) return true;
    if (document.querySelector('.pm-configure')) return true;

    var buy = document.querySelector(
      'product-form-component, .product-form-buttons, [data-block-type="buy-buttons"], form[action*="/cart/add"]'
    );
    if (!buy) return false;

    var link = document.createElement('a');
    link.className = 'pm-configure';
    link.href = target;
    link.innerHTML = 'Configure in 3D<small>Pick every part and see it before you buy</small>';

    buy.parentNode.insertBefore(link, buy);
    return true;
  }

  /* ==========================================================================
     2. STICKY TITLE ON PHONES

     On a phone the title sits above a tall gallery, so within one swipe it is
     gone and the rest of the page is a column of photos and buttons with
     nothing saying what they belong to. That matters most for someone who
     arrived from a TikTok link and is still deciding what they are looking at.

     A copy of the title is pinned rather than the title itself: pinning the
     real h1 would park a large heading across the screen permanently. This is
     a slim bar that appears only once the heading has scrolled away, carries
     the price too, and takes about 40px.

     IntersectionObserver rather than a scroll listener - it fires only when
     the heading actually crosses the boundary, instead of running on every
     frame of every scroll.
     ========================================================================== */
  var PHONE = '(max-width: 900px)';

  function mountStickyTitle() {
    if (!handle()) return true;
    if (!window.matchMedia || !window.matchMedia(PHONE).matches) return true;
    if (typeof IntersectionObserver === 'undefined') return true;
    if (document.querySelector('.pm-stickytitle')) return true;

    var details = document.querySelector('.product-details');
    var heading = details && details.querySelector('h1');
    if (!heading) return false;

    var bar = document.createElement('div');
    bar.className = 'pm-stickytitle';
    bar.setAttribute('aria-hidden', 'true');   /* the real h1 is the heading */

    var name = document.createElement('span');
    name.className = 'pm-stickytitle__name';
    name.textContent = heading.textContent.trim();
    bar.appendChild(name);

    var priceEl = details.querySelector('.price');
    if (priceEl) {
      var price = document.createElement('span');
      price.className = 'pm-stickytitle__price';
      price.textContent = priceEl.textContent.replace(/\s+/g, ' ').trim();
      bar.appendChild(price);

      /* The price changes with the variant, so keep the copy in step. */
      if (typeof MutationObserver !== 'undefined') {
        new MutationObserver(function () {
          price.textContent = priceEl.textContent.replace(/\s+/g, ' ').trim();
        }).observe(priceEl, { childList: true, subtree: true, characterData: true });
      }
    }

    document.body.appendChild(bar);

    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-shown', !entries[0].isIntersecting);
    }, {
      /* Fires as the heading passes under the site header, not the very top of
         the window - otherwise the bar appears while the title is still
         visible beneath it. */
      rootMargin: '-72px 0px 0px 0px',
      threshold: 0
    }).observe(heading);

    return true;
  }

  function run() {
    var a = mountConfigure();
    var b = mountStickyTitle();
    return a && b;
  }

  /* The buy button is rendered server-side but upgraded into a custom element,
     so give it a few chances rather than one. */
  var ticks = 0;
  var poll = window.setInterval(function () {
    ticks++;
    if (run() || ticks > 40) window.clearInterval(poll);
  }, 250);

  window.__pmProduct = { run: run, builders: BUILDERS };
})();
